import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { ThemeProvider } from "@mui/material/styles";
import { theme } from "./_rootConfig";

import { Provider } from "react-redux";
import store from "./redux/store";
import { Toaster } from "react-hot-toast";
import { toastOptions } from "./_rootConfig";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./config/msal";

const persistor = persistStore(store);

ReactDOM.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <MsalProvider instance={msalInstance}>
        <ThemeProvider theme={theme}>
          <Toaster toastOptions={toastOptions} />
          <App />
        </ThemeProvider>
      </MsalProvider>
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);

reportWebVitals();
